import React from "react";
import { UserProfile } from "contract/view-collection/user";

export const ProfileContext = React.createContext<
  UserProfile | null | undefined
>(undefined);
